import React from 'react'

const Booking = ({ booking }) => (
  <a href={`/events/${booking.id}`} className="text-muted">
    <div>{ booking.title } @ { booking.timeDescription }</div>
  </a>
)

export default Booking
